import { createSlice, createSelector } from '@reduxjs/toolkit'
//import { BASE_URL, OrganizationId_Guid, AuthToken } from '/features/storeconfig'

const initialState = {
  entities: {},
  status: 'idle', // idle loading success fail cloning
  error: null
}
const surveySlice = createSlice({
  name: 'surveys',
  initialState,
  reducers: {
    surveyHydrate(state, action) {
      state.status = 'success'
      
    },
    surveyModify(state, action) {
      const surveyData = action.payload
      state.entities[surveyData.SurveyId_Guid] = surveyData
    },
    surveyDelete(state, action) {
      const surveyData = action.payload
      delete state.entities[surveyData.SurveyId_Guid]
    },
    surveyClear(state, action) {
      state.status = 'idle'
    },
  }
})

export const { surveyModify, surveyAdd, surveyDelete, surveyHydrate, surveyClear } = surveySlice.actions

export default surveySlice.reducer

const selectSurveyEntities = (state) => state.surveys.entities
export const selectSurveyStatus = (state) => state.surveys.status
export const selectSurveyError = (state) => state.surveys.error

export const selectSurveys = createSelector(selectSurveyEntities, (entities) =>
  Object.values(entities)
)

export const selectSurveyById = (state, SurveyId_Guid) => {
  return selectSurveyEntities(state)[SurveyId_Guid]
}